import { type Ref, readonly, ref } from 'vue';

export type ConnectionState = 'online' | 'reconnecting';

const stateRef = ref<ConnectionState>('online');
let activeReconnects = 0;

/**
 * Read-only handle on the current connection state. Components subscribe
 * via {@link useConnectionState} to render the Reconnecting banner during
 * the ~30s nginx-502 window of a backend Docker restart.
 */
export const connectionState: Readonly<Ref<ConnectionState>> =
  readonly(stateRef);

function syncState(): void {
  const next = activeReconnects > 0 ? 'reconnecting' : 'online';
  if (stateRef.value !== next) {
    stateRef.value = next;
  }
}

export function beginReconnecting(): void {
  activeReconnects += 1;
  syncState();
}

export function endReconnecting(): void {
  activeReconnects = Math.max(0, activeReconnects - 1);
  syncState();
}

export function setConnectionState(next: ConnectionState): void {
  activeReconnects = next === 'reconnecting' ? 1 : 0;
  syncState();
}

export function useConnectionState(): Readonly<Ref<ConnectionState>> {
  return connectionState;
}
